import ProfileButton from "./ProfileButton";
import LetterIcon from "../Icons/LetterIcon";
import { getChildIdParam } from "../../helpers/helpers";

export function EmailMeButton(props) {
  const childId = getChildIdParam();
  
  return (
    <ProfileButton 
      classList="profile-button__email"
      requires={["commitment"]}
      ctaUrl={`/email-child/new/?childid=${childId}`}
      icon={<LetterIcon />}
      {...props}
    >
      Email Me
    </ProfileButton>
  );
}

export default EmailMeButton;